import {
  GET_COMBO_CUA_HANG,
  GET_COMBO_CUA_HANG_SUCCESS,
  GET_COMBO_CUA_HANG_FAILURE,
  CHUYEN_CUA_HANG,
  CHUYEN_CUA_HANG_SUCCESS,
  CHUYEN_CUA_HANG_FAILURE,
  THONG_TIN_CUA_HANG_HIEN_TAI,
  THONG_TIN_CUA_HANG_HIEN_TAI_SUCCESS,
  THONG_TIN_CUA_HANG_HIEN_TAI_FAILURE,
} from "actions/QuanLyCuaHang/actionTypes";
import { setToken } from "utils/cookieExtension";
import { setTokenBase } from "service/common";

const initialState = {
  getComboCuaHangLoading: false,
  listCuaHang: [],
  ComboCuaHangLoaded: false,
  thongTinCuaHang: {},
};

const getComboCuaHang = (state, action) => ({
  ...state,
  getComboCuaHangLoading: true,
  ComboCuaHangLoaded: true,
});

const getComboCuaHangSuccess = (state, action) => {
  return {
    ...state,
    getComboCuaHangLoading: false,
    listCuaHang: action.payload,
  };
};

const getComboCuaHangFailed = (state, action) => ({
  ...state,
  getComboCuaHangLoading: false,
  listCuaHang: [],
});

const chuyenCuaHang = (state, action) => ({
  ...state,
  chuyenCuaHangLoading: true,
});

const chuyenCuaHangSuccess = (state, action) => {
  setToken("userInfo", "token=" + action.payload);
  setToken("tokenMorman", action.payload);
  setTokenBase(action.payload, window.endPoint);
  return {
    ...state,
    chuyenCuaHangLoading: false,
  };
};

const chuyenCuaHangFailed = (state, action) => ({
  ...state,
  chuyenCuaHangLoading: false,
});
const thongTinCuaHangHienTai = (state, action) => ({
  ...state,
  thongTinCuaHangHienTaiLoading: true,
});

const thongTinCuaHangHienTaiSuccess = (state, action) => {
  return {
    ...state,
    thongTinCuaHangHienTaiLoading: false,
    thongTinCuaHang: action.payload,
  };
};

const thongTinCuaHangHienTaiFailed = (state, action) => ({
  ...state,
  thongTinCuaHangHienTaiLoading: false,
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMBO_CUA_HANG:
      return getComboCuaHang(state, action);
    case GET_COMBO_CUA_HANG_SUCCESS:
      return getComboCuaHangSuccess(state, action);
    case GET_COMBO_CUA_HANG_FAILURE:
      return getComboCuaHangFailed(state, action);
    case CHUYEN_CUA_HANG:
      return chuyenCuaHang(state, action);
    case CHUYEN_CUA_HANG_SUCCESS:
      return chuyenCuaHangSuccess(state, action);
    case CHUYEN_CUA_HANG_FAILURE:
      return chuyenCuaHangFailed(state, action);
    case THONG_TIN_CUA_HANG_HIEN_TAI:
      return thongTinCuaHangHienTai(state, action);
    case THONG_TIN_CUA_HANG_HIEN_TAI_SUCCESS:
      return thongTinCuaHangHienTaiSuccess(state, action);
    case THONG_TIN_CUA_HANG_HIEN_TAI_FAILURE:
      return thongTinCuaHangHienTaiFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
